import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { PublicLayout } from "@/components/PublicLayout";
import { CustomerProvider } from "@/context/CustomerContext";
import { RequireCustomer } from "@/components/account/AuthCard";
import AccountLogin from "@/pages/account/AccountLogin";
import AccountRegister from "@/pages/account/AccountRegister";
import VerifyEmail from "@/pages/account/VerifyEmail";
import ForgotPassword from "@/pages/account/ForgotPassword";
import ResetPassword from "@/pages/account/ResetPassword";
import MyRequests from "@/pages/account/MyRequests";
import RequestDetail from "@/pages/account/RequestDetail";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import CustomOrder from "@/pages/CustomOrder";
import Builder from "@/pages/Builder";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Policy from "@/pages/Policy";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminStyles from "@/pages/admin/AdminStyles";
import AdminFabrics from "@/pages/admin/AdminFabrics";
import AdminCompatibility from "@/pages/admin/AdminCompatibility";
import AdminAddons from "@/pages/admin/AdminAddons";
import AdminRequests from "@/pages/admin/AdminRequests";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminContent from "@/pages/admin/AdminContent";
import AdminInbox from "@/pages/admin/AdminInbox";

const Pub = ({ children }) => <PublicLayout>{children}</PublicLayout>;

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CustomerProvider>
        <SettingsProvider>
          <CartProvider>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/" element={<Pub><Home /></Pub>} />
              <Route path="/shop" element={<Pub><Shop /></Pub>} />
              <Route path="/product/:slug" element={<Pub><ProductDetail /></Pub>} />
              <Route path="/cart" element={<Pub><Cart /></Pub>} />
              <Route path="/checkout" element={<Pub><Checkout /></Pub>} />
              <Route path="/order-confirmation" element={<Pub><OrderConfirmation /></Pub>} />
              <Route path="/payment/success" element={<Pub><PaymentSuccess /></Pub>} />
              <Route path="/payment/cancel" element={<Pub><PaymentCancel /></Pub>} />
              <Route path="/custom-order" element={<Pub><CustomOrder /></Pub>} />
              <Route path="/builder" element={<Pub><Builder /></Pub>} />
              <Route path="/about" element={<Pub><About /></Pub>} />
              <Route path="/faq" element={<Pub><FAQ /></Pub>} />
              <Route path="/contact" element={<Pub><Contact /></Pub>} />
              <Route path="/policy/:key" element={<Pub><Policy /></Pub>} />
              <Route path="/account/login" element={<Pub><AccountLogin /></Pub>} />
              <Route path="/account/register" element={<Pub><AccountRegister /></Pub>} />
              <Route path="/account/forgot" element={<Pub><ForgotPassword /></Pub>} />
              <Route path="/verify-email" element={<Pub><VerifyEmail /></Pub>} />
              <Route path="/reset-password" element={<Pub><ResetPassword /></Pub>} />
              <Route path="/account" element={<Pub><RequireCustomer><MyRequests /></RequireCustomer></Pub>} />
              <Route path="/account/requests/:number" element={<Pub><RequireCustomer><RequestDetail /></RequireCustomer></Pub>} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="styles" element={<AdminStyles />} />
                <Route path="fabrics" element={<AdminFabrics />} />
                <Route path="compatibility" element={<AdminCompatibility />} />
                <Route path="addons" element={<AdminAddons />} />
                <Route path="requests" element={<AdminRequests />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="gallery" element={<AdminGallery />} />
                <Route path="content" element={<AdminContent />} />
                <Route path="inbox" element={<AdminInbox />} />
              </Route>
            </Routes>
          </CartProvider>
        </SettingsProvider>
        </CustomerProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
